<template>
  <aside ref="aside" class="sidebar" :style="{ transform: open ? 'translateX(0)' : 'translateX(-100%)' }">
    <nav ref="nav" :style="{ backgroundColor: `${bg}EE` }">
      <h1 class="honk-large">bricks</h1>

      <ul>
        <li>
          <a @click="showEditorModal()">open editor</a>
        </li>
      </ul>

      <h2 class="honk-regular">wall presets</h2>
      <ul>
        <li v-for="wall in walls" :key="wall.id">
          <a @click="onSelectWall(wall.id)" :class="{ selected: selectedWall === wall.id }">
            {{ wall.name }}
          </a>
        </li>
      </ul>
    </nav>
    <div class="tab" :style="{
      transform: (mobile && open) ? 'scaleX(-1)' : (mobile && !open) ? 'scaleX(1)' : (!mobile) ? 'none' : 'none',
      right: (mobile && open) ? '0' : (mobile && !open) ? '-40px' : (!mobile) ? '-40px' : '0',
    }">
      <button @click="toggle" :style="{
        transform: open ? 'rotate(359deg)' : 'rotate(0deg)',
      }">
        ⚙️
      </button>
    </div>
  </aside>
</template>

<script>
import { emitter } from '@/util/emitter.js';
import { getPresetNames } from '@/util/walls/load-wall-bpl.js';
import { loadWall } from '@/util/walls/load-wall-bpl.js';
import * as wall from '@/components/WallComponent.vue';

export default {
  name: 'SidebarComponent',
  props: {
    bg: {
      type: String,
      default: '#B0B0B0',
    },
  },
  data() {
    return {
      mobile: this.isMobile(),
      open: !this.isMobile() || this.getSidebarParam(),
      walls: getPresetNames().map(id => ({
        name: id.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' '),
        id,
      })),
      selectedWall: wall.getQueryParam(),
    };
  },
  methods: {
    loadWall,
    isMobile() {
      return window.innerWidth < 400;
    },
    toggle() {
      this.open = !this.open;
    },
    getSidebarParam() {
      const url = new URL(window.location);
      return !!url.searchParams.get('sb');
    },
    /** Show the wall editor and hide sidebar */
    showEditorModal(config = undefined) {
      emitter.emit('show-modal-editor', config);

      this.open = false;
    },
    updateMobile() {
      this.mobile = this.isMobile();
    },
    onSelectWall(id) {
      this.loadWall(id);
      emitter.emit('load-wall', id);
      this.selectedWall = id;
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateMobile);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateMobile);
  },
};
</script>

<style scoped>
h1 {
  margin: 10px 0;
  font-variation-settings:
    "MORF" 15,
    "SHLN" 50;
  cursor: default;
}
h2 {
  margin: 10px 0;
  font-variation-settings:
    "MORF" 15,
    "SHLN" 50;
  cursor: default;
}
.tab {
  position: absolute;
  top: 10px;
  right: 0;
  width: 40px;
  height: 40px;
  background-color: #FFFF85;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: inset 1px 0 3px rgba(0, 0, 0, 0.2), inset 2px 0 3px rgba(0, 0, 0, 0.2), 0 1px 8px rgba(0, 0, 0, 0.4);
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  z-index: 9000;
  transform: scaleX(-1);
}
@media (min-width: 400px) {
  .tab {
    right: -40px;
  }
}
.tab button {
  background: none;
  border: none;
  color: inherit;
  font-size: 20px;
  cursor: pointer;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.4s ease;
}


.sidebar {
  position: fixed;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.4);
  transition: transform 0.2s ease;
  z-index: 9001;
}

@media (min-width: 400px) {
  .sidebar {
    width: 240px;
  }
}

.sidebar nav {
  height: 100%;
  min-width: 0;
  width: 100%;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
}

.sidebar nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  padding-bottom: 20px;
}

.sidebar nav ul li {
  width: 100%;
}

.sidebar nav ul li a {
  display: block;
  text-decoration: none;
  color: #333;
  font-weight: 500;
  transition: color 0.2s ease;
  width: 100%;
  padding: 4px 0;
  cursor: pointer;
}

.sidebar nav ul li a:hover, .sidebar nav ul li a.selected {
  text-decoration: underline 2px #FFFF85;
  text-underline-offset: .3rem;
}
</style>
